import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-white py-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo and Download Link */}
        <div>
          <img src="https://cdn.shopify.com/s/files/1/0649/7687/9773/files/iFLO_PRO_Logo.White_9e04ab02-f15d-451c-8d5e-260c4bf70526.png?v=1718996114" alt="iFLO PRO Logo" className="w-32" />
          <div className="mt-4 flex flex-col space-y-2">
            <a href="https://play.google.com/store/apps/details?id=com.iflo.pro&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn.shopify.com/s/files/1/0768/7353/1706/files/MicrosoftTeams-image_97.png?v=1733753200" alt="Get it on Google Play" className="h-12 border-[1px] border-white rounded-md" />
            </a>
            <a href="https://apps.apple.com/us/app/iflo-pro/id6736655924" target="_blank" rel="noopener noreferrer">
              <img src="https://cdn.shopify.com/s/files/1/0768/7353/1706/files/Download_on_the_App_Store_Badge_svg.webp?v=1733753485" alt="Download on the App Store" className="h-12" />
            </a>
          </div>
        </div>

        {/* Navigation Links */}
        <div>
          <h3 className="font-bold">iFLO Pro</h3>
          <ul className="mt-2 space-y-2">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/signup" className="hover:underline">Become a Pro</a></li>
            <li><a href="/contact-us" className="hover:underline">Support</a></li>
            <li><a href="/login" className="hover:underline">Login</a></li>
            <li><a href="/news" className="hover:underline">News</a></li>
            <li><a href="/about" className="hover:underline">iFLO Pro Formula</a></li>
            <li><a href="/iflo-insurance" className="hover:underline">iFLO Insurance</a></li>
          </ul>
          <h3 className="font-bold mt-6">Connect with iFLO®</h3>
          <div className="flex space-x-4 mt-2">
            <a href="https://www.iflopros.com/#https://www.facebook.com/people/iFLO/61555642498120/" className="hover:opacity-80">
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/my.iflo/?g=5" className="hover:opacity-80">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@my.iflo?_t=8ix3aZEMeDO&_r=1" className="hover:opacity-80">
              <i className="fa-brands fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@iFLO.SmartHVAC" className="hover:opacity-80">
              <i className="fa-brands fa-youtube"></i>
            </a>
          </div>
        </div>

        {/* Contact and Legal Links */}
        <div>
          <ul className="space-y-2">
            <li><a href="/search" className="hover:underline">Search</a></li>
            {/*<li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
            <li><a href="/terms-of-service" className="hover:underline">Terms of Service</a></li>*/}
          </ul>
          <p className="mt-4">(888) 443-4356</p>
          <p className="mt-2">Great Innovations, LLC.</p>
          <p>2301 SW 145th Ave Miramar, FL 33027</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
